import ChangeNotificationStatus from 'owa-service/lib/contract/ChangeNotificationStatus';
import getStore from '../store/store';

/**
 * Gets current state of shared calendar options store
 */
export default function(): { [folderId: string]: ChangeNotificationStatus } {
    return getStore().currentState;
}
